export default __webpack_public_path__ + "static/media/gy.0cb6e816.svg";